import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import selectors from '../../selectors/selectors';
import { getFacebookAccessToken, postPlatformRegistration, postPlatformRegistrationAddition, putPlatformRegistration } from '../../redux/actions/settingsActions.js';

const actions = {
  facebook: (state, query) => {
    if (query.error) {
      window.location = state.redirectUri;
      return;
    }
    getFacebookAccessToken(query.code, (resp = {}) => {
      const payload = {
        id: state.platformRegistrationId,
        platformRegistrationId: state.platformRegistrationId,
        platformId: state.platformId,
        serviceProviderId: state.serviceProviderId,
        location: state.location,
        name: state.name,
        authenticationToken: resp.access_token,
        deleted: '0',
        status: 'Active',
      };
      const method = state.platformRegistrationId ? putPlatformRegistration : postPlatformRegistration;
      return method(payload, (data) => {
        const id = state.platformRegistrationId || (data || {}).result;
        window.location = `${state.redirectUri}/${id}`;
      });
    });
  },
  nylas: (state, query) => {
    const payload = {
      email_address: decodeURIComponent(query.email_address),
      provider_profile_id: query.account_id,
      name: state.name,
      token: query.access_token,
      platform: 'Nylas',
      service_location_id: ['null', 'undefined'].includes(state.locationId) ? null : state.locationId || null,
      user_id: ['null', 'undefined'].includes(state.userId) ? null : state.userId || null,
    };
    postPlatformRegistrationAddition(state.serviceProviderId, payload, () => {
      window.location = state.sourceHref;
    });
  },
};

const OauthScreen = () => {
  const query = useSelector(selectors['query']);

  const [lastState, setLastState] = useState('');

  useEffect(() => {
    if (query.state === lastState) {
      return;
    }
    setLastState(query.state);
    let state;
    try {
      state = JSON.parse(atob(decodeURIComponent(query.state)));
    } catch (e) {
      console.error('err', e);
    }
    if (!state || typeof state !== 'object') {
      console.error(state);
      return;
    }

    const action = actions[state.platformCode];
    if (typeof action === 'function') {
      action(state, query);
    }
  }, [query.state]);

  return null;
};

export default OauthScreen;
